<template>
  <div id="sseek">
    <div class="sseek_bar" @click.stop="sseek_barclick">
      <div :class="{sseekactive:sucai=='mods'}" data-qf="sseek_mods">模型</div>
      <div :class="{sseekactive:sucai=='mats'}" data-qf="sseek_mats">材质</div>
      <div :class="{sseekactive:sucai=='maps'}" data-qf="sseek_maps">贴图</div>
    </div>
    <seek seekname='sseek'></seek>
    <el-backtop target="#sseek" :right="20">UP</el-backtop>
  </div>
</template>

<script>
import seek from 'views/seek/seek.vue'
export default {
  name:'sseek',
  data() {
    return {
      sucai:'',
    }
  },
  created() {
    const pathstr = this.$route.fullPath
    if(pathstr.includes('mods')){
      this.$store.state.searchselect = 'mods'
      this.sucai = 'mods'
    }else if(pathstr.includes('mats')){
      this.$store.state.searchselect = 'mats'
      this.sucai = 'mats'
    }else if(pathstr.includes('maps')){
      this.$store.state.searchselect = 'maps'
      this.sucai = 'maps'
    }
  },
  methods: {
    sseek_barclick(e){
      const qf = e.target.dataset.qf
      switch(qf){
        case('sseek_mods'):
        this.sucai = 'mods'
        this.$store.state.searchselect = 'mods'
        Object.assign(this.$store.state['sseekquery'],{sucai:'mods',classid:0,classcid:0,styleid:0,type:0,isone:0,fname:'',search:this.$store.state.searchinput,page:1})
        this.utils.seekgetitem(this.$store,'sseek')
        this.$router.push(this.utils.urlEncode('sseek',this.$store.state['sseekquery']))
        break
        case('sseek_mats'):
        this.sucai = 'mats'
        this.$store.state.searchselect = 'mats'
        Object.assign(this.$store.state['sseekquery'],{sucai:'mats',classid:0,classcid:0,styleid:0,type:0,isone:0,fname:'',search:this.$store.state.searchinput,page:1})
        this.utils.seekgetitem(this.$store,'sseek')
        this.$router.push(this.utils.urlEncode('sseek',this.$store.state['sseekquery']))
        
        break
        case('sseek_maps'):
        this.sucai = 'maps'
        this.$store.state.searchselect = 'maps'
        Object.assign(this.$store.state['sseekquery'],{sucai:'maps',classid:0,classcid:0,styleid:0,type:0,isone:0,fname:'',search:this.$store.state.searchinput,page:1})
        this.utils.seekgetitem(this.$store,'sseek')
        this.$router.push(this.utils.urlEncode('sseek',this.$store.state['sseekquery']))
        break
      }
    }
  },
  components:{
    seek
  }
}
</script>

<style>
.sseek_bar{
  padding: 0 65px;
  display: flex;
  height: 58px;
  border-bottom: 1px solid rgb(211, 217, 223);
}
.sseek_bar > div{
  line-height: 58px;
  width: 38px;
  margin-right: 50px;
  color: rgb(93, 100, 110);
  font-size: 17px;
  cursor: pointer;
}
.sseek_bar > .sseekactive{
  font-weight: 600;
  color: rgb(67, 75, 87);
  border-bottom: 3px solid rgb(19, 137, 255);
}
</style>